import React, { useState } from 'react'
import TableDetails from './TableDetails'
import './ListOfTable.css'
import * as AiIcons from 'react-icons/ai';
import Ads from './Ads';

function ListOfTable() {
    const [listOfTable, setListOfTable] = useState(Array.from({length:78 },(_, i) => i + 1))
    const [selectedTable,setSelectedTable] =useState(1);
    const [interedTable,setInteredTable]= useState()

    const handleChangeFuntion=(action,table)=>{
        if(action==='standeard' && !interedTable){
            alert('Pls Enter The Table Number')
            return ;
        }
        if(action==='standeard' && (interedTable<0 || interedTable>100)){
            alert('Number Should be Between 0 to 100')
            return ;
        }
        if(action==='manual'){
            setInteredTable('') 
        }
        setSelectedTable(table);
    }


    return ( 
        <div className="row">
            <div  className='col-md-2 col-xs-10' style={{fontFamily:'times new roman', marginRight:'4px'}}>
                <div className={false ? 'nav-menu active d-none d-md-block d-lg-none d-none d-sm-block' : 'nav-menu'} id='navbar' >
                    <div className='table-heading-cnt' style={{marginTop:'3px',marginLeft:'5px'} } >
                        <b style={{display:'flex', marginTop:'12px'}}>
                            <AiIcons.AiTwotoneBulb />
                            <h2 className="text-xl" style={{fontFamily:'times new roman', marginLeft:'12px'}}>Table List</h2>
                        </b>
                    </div>
                    <div className='table-heading-cnt' > 
                        {/* <span className='tableBox-cnt' >Inter table</span> */}
                        <div className='input-second-cnt' style={{padding:'10px'}}>
                            <input className='input-cnt form-control'value={interedTable} placeholder='Enter Table Number' onChange={(e)=>{setInteredTable(e.target.value)}} type="number"  max={100} />
                            <button className='button' onClick={()=>handleChangeFuntion("standeard",interedTable)} >Go </button>
                        </div>
                    </div>
                    {listOfTable.map((value,index)=>(
                    <div className='table-heading-cnt'onClick={()=>handleChangeFuntion("manual",value)} style={{backgroundColor:value==selectedTable ? "#3b82f6" : "rgba(0, 0, 0, 0.2)",cursor:'pointer'}} >
                    <span ><AiIcons.AiFillPushpin /></span>
                    <div className='tableBox-cnt'>Table {value}</div>
                </div>
                    )) }
                </div>
            </div>
            
            <div className='col-md-7 col-xs-10 course-area card'>
                <TableDetails table={selectedTable}/>
            </div>

            <div className="col-md-3 col-xs-10">
                <Ads></Ads>
            </div>
        </div>

    )
}

export default ListOfTable